import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
@Component({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currRatio:{},
    ratioList:{
      default:[]
    }
  },
  components: {
  },
  watch: {
    visible: {
      handler(val) {
        this.show = val
      },
      immediate: true
    },
    currRatio: {
      handler(val) {
        this.chooseRatio = val
      },
      immediate: true
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class RatioPopup extends Vue{
  state = new PageState();
  chooseRatio = '9:16' ;
  show= false;
  // rateList = [{idx:0,value:'16:9'},{idx:1,value:'9:16'},{idx:2,value:'4:3'},{idx:3,value:'3:4'},{idx:4,value:'1:1'}];
  mounted() {
    console.log('-------ratioList',JSON.stringify(this.$props))
    this.chooseRatio = this.$props.currRatio;
    console.log('-------this.chooseRatio',this.$props.currRatio)
  }
  closePopup() {
    this.$emit('close')
  }
  /**
   * 确定
   */
  confirmSubtitle() {
    this.$emit('close')
  }
  submitRate(){
    this.$emit('changeRatio',this.chooseRatio)
    this.$emit('close')
  }
}